import React from 'react'
import Link from '../actions/Link'
import CheckboxInput from './CheckboxInput'
import Separator from '../helpers/Separator'

const NAWrapper = ({ children, onChange, value, active }) => {
  if (!active) return children
  const selected = value === null

  return (
    <>
      <div style={{ opacity: selected ? 0.3 : 1 }}>{children}</div>
      <Separator weight={3} />
      <Link onClick={() => onChange(selected ? undefined : null)}>
        <CheckboxInput label="N/A" value={selected} />
      </Link>
    </>
  )
}

export default NAWrapper
